import { JournalEntrySourceFilter } from "@common/schemas/domains/accounting/journalEntry";

export const journalEntrySourceFilterToLabelMap = {
    [JournalEntrySourceFilter.Transaction]: "Transaction",
    [JournalEntrySourceFilter.ManualJournalEntry]: "Manual Journal",
    [JournalEntrySourceFilter.QuickBooksOnline]: "QuickBooks Online",
    [JournalEntrySourceFilter.QuickBooksDesktop]: "QuickBooks Desktop",
    [JournalEntrySourceFilter.Xero]: "Xero",
    [JournalEntrySourceFilter.MigratedData]: "Migrated data",
    [JournalEntrySourceFilter.Loan]: "Loan",
    [JournalEntrySourceFilter.OpeningBalance]: "Opening Balance",
    [JournalEntrySourceFilter.Bill]: "Bill",
    [JournalEntrySourceFilter.Invoice]: "Invoice",
    [JournalEntrySourceFilter.Recurring]: "Recurring",
};
